import React from 'react';
import UserAvatar from '../common/UserAvatar';

const tableConfig = (props) => ({
    columns: [
        { title: 'Promo Code', field: 'promoCode', filterAndSearch: true},
        { title: 'Discount', field: 'discount', filterAndSearch: true },
        { title: 'Uses', field: 'uses', filterAndSearch: true },
        { title: 'Start date', field: 'startDate', filterAndSearch: true },
        { title: 'End date', field: 'endDate', filterAndSearch: true },
        { title: 'Status', field: 'status', filterAndSearch: true }
    ]
})

export const data = [
    {
        "_id": "5f3cca24e3e24beaf8bb3a29",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    },
    {
        "_id": "5f3cca24ee19b6c5b0eaca30",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    },
    {
        "_id": "5f3cca246e2c873a4887d9d3",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    },
    {
        "_id": "5f3cca24a6a3f35bdd4a6702",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    },
    {
        "_id": "5f3cca24bf06c712840c88f4",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    },
    {
        "_id": "5f3cca24ab8ae71637e883df",
        "promoCode": "ENJOY_50",
        "discount": "50%",
        "uses": "15/100",
        "startDate": "April 04, 2020",
        "endDate": "April 14, 2020",
        "status": "Active"
    }
];

export default tableConfig;